import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer" }

import { showLogoutDialogue } from "@/components/Dialogues/useData/useDialogues";
import login from "@/../CsdPublic/login";

import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutDialogues',
  setup(__props) {

const { isLogin } = storeToRefs(publicStore());
const onLogout = () => {
  showLogoutDialogue.value = false;
  login.logOut();
  isLogin.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showLogoutDialogue),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showLogoutDialogue) ? (showLogoutDialogue).value = $event : null)),
    width: "240",
    class: "custom-dialog",
    "align-center": "",
    "show-close": false,
    title: "提示",
    center: "",
    style: { '--el-border-radius-base': '16px' }
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          class: "cancel-btn",
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showLogoutDialogue.value = false))
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" 取消 ")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "ok-btn",
          type: "primary",
          onClick: onLogout
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" 确定 ")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "body" }, "是否确认退出登录？", -1))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})